var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgListsGrey = function SvgListsGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h3.385v3.385H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M0 17.053h22.824V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 9)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.496.496A1.693 1.693 0 1 0 2.89 2.89 1.693 1.693 0 0 0 .496.496",
    fill: "#B7B7B7",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B7B7B7",
    mask: "url(#d)",
    d: "M5.716 2.193h17.108v-1H5.716zM.496 7.33A1.693 1.693 0 1 0 2.89 9.724 1.693 1.693 0 0 0 .496 7.33m5.22 1.697h17.108v-1H5.716zm-5.22 5.137a1.693 1.693 0 1 0 2.394 2.394 1.693 1.693 0 0 0-2.394-2.394m5.22 1.696h17.108v-1H5.716z"
  }))));
};
export { SvgListsGrey as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0ibDh3NHI1dXZuYSIgZD0iTTAgMGgzLjM4NXYzLjM4NUgweiIvPgogICAgICAgIDxwYXRoIGlkPSI2cmF5aWRrOXBjIiBkPSJNMCAxNy4wNTNoMjIuODI0VjBIMHoiLz4KICAgIDwvZGVmcz4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcgOSkiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxtYXNrIGlkPSJ5ZjJueDIxeXNiIiBmaWxsPSIjZmZmIj4KICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2w4dzRyNXV2bmEiLz4KICAgICAgICAgICAgPC9tYXNrPgogICAgICAgICAgICA8cGF0aCBkPSJNLjQ5Ni40OTZBMS42OTMgMS42OTMgMCAxIDAgMi44OSAyLjg5IDEuNjkzIDEuNjkzIDAgMCAwIC40OTYuNDk2IiBmaWxsPSIjQjdCN0I3IiBtYXNrPSJ1cmwoI3lmMm54MjF5c2IpIi8+CiAgICAgICAgPC9nPgogICAgICAgIDxtYXNrIGlkPSIyajF4Z216dXRkIiBmaWxsPSIjZmZmIj4KICAgICAgICAgICAgPHVzZSB4bGluazpocmVmPSIjNnJheWlkazlwYyIvPgogICAgICAgIDwvbWFzaz4KICAgICAgICA8cGF0aCBmaWxsPSIjQjdCN0I3IiBtYXNrPSJ1cmwoIzJqMXhnbXp1dGQpIiBkPSJNNS43MTYgMi4xOTNoMTcuMTA4di0xSDUuNzE2ek0uNDk2IDcuMzNBMS42OTMgMS42OTMgMCAxIDAgMi44OSA5LjcyNCAxLjY5MyAxLjY5MyAwIDAgMCAuNDk2IDcuMzNNNS43MTYgOS4wMjdoMTcuMTA4di0xSDUuNzE2ek0uNDk2IDE0LjE2NGExLjY5MyAxLjY5MyAwIDEgMCAyLjM5NCAyLjM5NCAxLjY5MyAxLjY5MyAwIDAgMC0yLjM5NC0yLjM5NE01LjcxNiAxNS44NmgxNy4xMDh2LTFINS43MTZ6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";